module.exports = __webpack_public_path__ + "static/img/digitalize-new.2b6365b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/digitalize-new.png
// module id = MWmp
// module chunks = 0